import React from "react";

import { InputWrapper, Text, Toggle, toast } from "@performyard/py-components";

import { GridCol } from "../../../../components/Grid";
import Spacer from "../../../../components/Spacer";

const TOGGLE_SIZE = 24;

type SettingsToggleProps = {
	id: string;
	label: string;
	description: string;
	checked: boolean;
	onCheckedChange: (val: boolean) => Promise<void>;
	labelMaxWidth?: string;
	dataTestId?: string;
};

export const SettingsToggle = ({
	id,
	label,
	description,
	checked,
	onCheckedChange,
	labelMaxWidth = "max-w-[300px]",
	dataTestId,
}: SettingsToggleProps) => {
	const handleToggle = async (val: boolean) => {
		try {
			await onCheckedChange(val);
		} catch {
			toast.error("Unable to save settings.");
		}
	};

	return (
		<GridCol span={5}>
			<InputWrapper
				labelPosition="left"
				justify="between"
				id={id}
				disableLabelClick
				label={
					<>
						<Text size="paragraph-2" weight="semi-bold" color="neutral-9">
							{label}
						</Text>
						<Spacer height={1} />
						<div className={labelMaxWidth}>
							<Text size="paragraph-3" weight="regular" color="neutral-9">
								{description}
							</Text>
						</div>
					</>
				}
			>
				<Toggle
					onCheckedChange={handleToggle}
					checked={checked}
					color={checked ? "primary" : "neutral"}
					showText
					size={TOGGLE_SIZE}
					data-testid={dataTestId}
					aria-labelledby={`label-${id}`}
				/>
			</InputWrapper>
		</GridCol>
	);
};
